var {AmpersandState} = require('catalog/libs');

/**
 * Dynamic Tab Container State
 */
var DynamicTabContainerState = AmpersandState.extend({

    initialize: function() {
        this.isLoading = false;
    },

    props: {
        isMobile: 'boolean',
        isLoading: 'boolean',
        activeTabID: 'string',
        currentDynamicTabConstant: 'string',
        validTabConstants: 'array',
        tabClass: 'string',
        pool: 'object',
        serviceURLs: 'object'
    }

});


module.exports = DynamicTabContainerState;
